import styled from 'styled-components';
import TextInputWrapper from '@anm/components/form/TextInput/Wrapper';

export const RedeemCouponWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  ${TextInputWrapper} {
    flex: 1;
    input {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: 0 none;
      margin-bottom: 0;
      font-size: 14px;
    }
  }
  button {
    font-size: 14px;
  }
`;
